import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { c as a } from "../../clsx-OuTLNxxd.js";
import { PriceValue as I } from "../PriceBox/PriceBox.js";
const w = "PriceItem-module_fare-label__Vwpnw",
  P = "PriceItem-module_price__tST7M",
  f = "PriceItem-module_per-guest__KAnqc",
  h = "PriceItem-module_price-item__q54pd",
  C = "PriceItem-module_variant-row__2NVD3",
  N = "PriceItem-module_variant-row-compact__QX43r",
  R = "PriceItem-module_variant-column__-Lhea",
  x = "PriceItem-module_variant-small__JkT1D",
  r = {
    fareLabel: w,
    price: P,
    perGuest: f,
    priceItem: h,
    variantRow: C,
    variantRowCompact: N,
    variantColumn: R,
    variantSmall: x
  },
  j = _ref => {
    let {
      price: t,
      priceType: l,
      showFareLabel: s,
      variant: m,
      layout: c,
      perGuestLabel: i,
      lowestAvailableFareLabel: o,
      chipBackgroundColor: _,
      className: d,
      fareClassName: p,
      priceClassName: v,
      perGuestClassName: u
    } = _ref;
    return t ? /* @__PURE__ */n("div", {
      className: a(r.priceItem, {
        [r.variantSmall]: m == "small",
        [r.variantNormal]: m == "normal",
        [r.variantBig]: m == "big",
        [r.variantRow]: c == "row",
        [r.variantRowCompact]: c == "row-compact",
        [r.variantColumn]: c == "column"
      }, d),
      children: [s && /* @__PURE__ */e("div", {
        className: a(r.fareLabel, p),
        children: t.fareLabel
      }), /* @__PURE__ */e(I, {
        price: t,
        className: a(r.price, v),
        chipBackgroundColor: _,
        priceType: l
      }), (i || o) && /* @__PURE__ */n("div", {
        className: a(r.perGuest, u),
        children: [i && /* @__PURE__ */e("div", {
          children: i
        }), o && /* @__PURE__ */e("div", {
          children: o
        })]
      })]
    }) : null;
  };
export { j as PriceItem };